<div class="container-fluid p-0 bg-white h-100"id="Help-Section">
    <div class="row">
        <div class="col-md-12">
            <div id="help-section-component" class="p-5">
                <div class="container">
                    <div class="card-body">
                        <div class="row">
                            <!-- <div class="col-12  text-right">
                    <i class="flaticon2-cross cursor-pointer"
                        (click)="closeHelpSection()" style="color: #CA071C;"></i>
                </div> -->

                        </div>
                        <div class="row">
                            <div class="col-lg-12 col-xl-12 ">
                                <div class="col-md-8 mt-2">
                                    <h2>
                                        <b>{{ 'HelloHowCanWeHelp' | localize }} </b>
                                    </h2>
                                </div>
                            </div>
                            <div class="col-lg-12 col-xl-12 ">
                                <div class="col-md-8">
                                    <form>
                                        <!-- search box -->
                                        <div class="form-group has-search w-70">
                                            <ng-select [items]="question" bindLabel="que"
                                                       bindValue="name" placeholder="{{'AskAQuestion' | localize}}"
                                                       [clearSearchOnAdd]="true" [closeOnSelect]="true"
                                                       (change)="onAddCard($event.name)"
                                                       [searchable]="true">
                                                <!-- <ng-template ng-header-tmp>
                                        Categories
                                    </ng-template> -->

                                                <ng-template ng-label-tmp let-item="item">
                                                    <div (click)="onAddCard(item.sectionName, item.sectionId)">
                                                        <img height="15" width="15"
                                                             [src]="item.avatar" />
                                                        <b>{{item.que | localize}}</b>
                                                    </div>
                                                </ng-template>

                                                <ng-template ng-option-tmp let-item="item"
                                                             let-index="index">
                                                    <div (click)="onAddCard(item.sectionName, item.sectionId)">
                                                        <img height="15" width="15"
                                                             [src]="item.avatar" />
                                                        <b class="ml-3">{{item.que | localize}}</b>
                                                    </div>
                                                </ng-template>
                                            </ng-select>


                                        </div>
                                    </form>
                                    <div class="ml-2 text-muted">
                                        {{'OrChooseaCategorytoCuicklyFindTheHelpYouNeed'| localize}}
                                    </div>
                                </div>
                            </div>
                        </div>
                         

                        <div class="helpsection-contents">
                            <div class="tabs">
                                <div class="container">
                                    <div class="row">
                                        <div class="col-md-12 p-0">
                                            <ng-container *ngFor="let item of helptext; let i=index;">
                                                <a (click)="onAddCard(item.name)"
                                                   class="btn btn-lg btn-outline-primary ml-2">
                                                    <img [src]="item.avatar" alt="">
                                                    <h6 class="mt-4">
                                                        {{item.name | localize}}
                                                    </h6>
                                                </a>
                                            </ng-container>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
